<script setup>
import EditOrganisation from '@/Pages/Organisations/Edit.vue';
import { useForm } from '@inertiajs/inertia-vue3';

const form = useForm(props.organisation);

const props = defineProps({
    organisation: {
        type: Object,
        required: true
    },
    app: {
        type: Object,
        required: true
    },
})

const updateOrganisation = () => {
	form.put('/organisations/' + props.organisation.id)
}

</script>

<template>
	<EditOrganisation 
		:organisation="form" 
		:app="app"
		@update:organisations="updateOrganisation"
	/>
</template>